module.exports = __webpack_public_path__ + "media/images/slide-18-a5a530d4c136acf60c92d0f72b198d93.jpg";